import { Component, OnInit, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { ElementRef, HostListener, ViewChild } from "@angular/core";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-sub-navbar",
  templateUrl: "./sub-navbar.component.html",
  styleUrls: ["./sub-navbar.component.scss"],
})
export class SubNavbarComponent implements OnInit {
  @ViewChild("autoSuggestion") autoSuggestion!: ElementRef;
  typeahead: FormControl = new FormControl();
  @Input() searchKey = "Illustration";
  @Input() searchword = "";
  illusData: any = [];
  collectionData: any = [];
  aiIllusData: any = [];
  suggestions: string[] = [];
  isSuggestionsLoaded: boolean = false;

  constructor(
    private dataService: DataService,
    public router: Router,
    private route: ActivatedRoute
  ) {}

      getSEOImage(url: string): string {
      return buildSEOImageUrl(url);
    }


  async ngOnInit(): Promise<void> {
    (await this.dataService.getIllustrationService()).subscribe(
      (singleservice) => {
        this.illusData = [];
        this.illusData = singleservice;
        this.typeahead.setValue(this.searchword);
        if (this.typeahead.value?.length > 0) {
          this.suggest();
        }
      }
    );
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.collectionData = [];
        this.collectionData = singleservice;
        this.typeahead.setValue(this.searchword);
        if (this.typeahead.value?.length > 0) {
          this.suggest();
        }
      }
    );
    (await this.dataService.getAIIllustrationService()).subscribe(
      (singleservice) => {
        this.aiIllusData = [];
        this.aiIllusData = singleservice;
        this.typeahead.setValue(this.searchword);
        if (this.typeahead.value?.length > 0) {
          this.suggest();
        }
      }
    );
    this.route.queryParams.subscribe((params) => {
      if (params["searchKey"]) {
        this.searchKey = params["searchKey"];
      } else {
        this.searchKey = "Illustration";
      }
    });
    // this.route.params.subscribe((params) => {
    //   if (params["searchKey"]) {
    //     this.searchKey = params["searchKey"];
    //   } else {
    //     this.searchKey = "Illustration";
    //   }
    // });
  }

  suggest() {
    if (this.typeahead.value.length > 0) {
      this.searchKey == "Illustration"
        ? (this.suggestions = this.illusData.filter(
            (c) =>
              !c.isAIIllustration &&
              c.title.toLowerCase().includes(this.typeahead.value.toLowerCase())
          ))
        : this.searchKey == "Collections"
        ? (this.suggestions = this.collectionData
            .filter(
              (c) =>
                !c.isAICollection &&
                c.collectionName
                  .toLowerCase()
                  .includes(this.typeahead.value.toLowerCase())
            )
            .slice(0, 5))
        : this.searchKey == "AI Images"
        ? (this.suggestions = this.aiIllusData
            .filter(
              (c) =>
                c.isAIIllustration &&
                c.title
                  .toLowerCase()
                  .includes(this.typeahead.value.toLowerCase())
            )
            .slice(0, 5))
        : [];
    } else {
      this.suggestions = [];
    }
    // console.log(this.suggestions);
  }

  setSearchKey(data) {
    data == "illus"
      ? (this.searchKey = "Illustration")
      : data == "collect"
      ? (this.searchKey = "Collections")
      : data == "aiImage"
      ? (this.searchKey = "AI Images")
      : (this.searchKey = "");
  }

  navigateTo() {

    if(!this.typeahead.value || this.typeahead.value.trim() === ""){
      return;
    }
    
    this.router.navigate(["/search"], {
      queryParams: { value: this.typeahead.value, searchKey: this.searchKey },
    });
    //console.log("enter pressed");
    this.suggestions = [];
    if (this.typeahead?.setValue) {
      this.typeahead.setValue("");
    }
  }

  @HostListener("document:click", ["$event"])
  handleClickOutside(event: MouseEvent) {
    const clickedInside = this.autoSuggestion?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.suggestions = [];
      if (this.typeahead?.setValue) {
        this.typeahead.setValue("");
      }
    }
  }

  onSuggestionClick(): void {
    this.suggestions = []; // Clears suggestions
    this.typeahead.setValue(""); // Optional: clears input value
  }
}
